// Avatar: mostra a imagem quando houver `src`; senão, iniciais (sem dependência).
function initials(name: string, email: string): string {
  const src = (name || email || '?').trim();
  const parts = src.split(/[\s@.]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return src.slice(0, 2).toUpperCase();
}

export function InitialsAvatar({
  name = '', email = '', src, size = 56,
}: { name?: string; email?: string; src?: string; size?: number }) {
  if (src) {
    return (
      <img
        src={src}
        alt={name || email}
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="shrink-0 rounded-full object-cover"
      />
    );
  }
  return (
    <div
      style={{ width: size, height: size, fontSize: size * 0.38 }}
      className="flex shrink-0 items-center justify-center rounded-full bg-primary/15 font-bold text-primary"
      aria-hidden
    >
      {initials(name, email)}
    </div>
  );
}
